// src/firebase/firebase-config.js

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth'; // or other Firebase services
import "firebase/storage";

// Firebase configuration for the default project
const defaultFirebaseConfig = {
  apiKey: "AIzaSyA9jtigMm7Y93PSo31ZWrTeASQ-IwZtgkA",
  authDomain: "amposter2026.firebaseapp.com",
  databaseURL: "https://amposter2026-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "amposter2026",
  storageBucket: "amposter2026.firebasestorage.app",
  messagingSenderId: "890351926290",
  vapidKey: "BEtBXv7O8RaxLlOCbQSxD9JTr_62HlOQ3HzWjkE-bDKZMhbpKdc5q9RfXkjyNH-kGzL_tS_Ay4qcYgZeIwAWBvE",
  appId: "1:890351926290:web:76369687d7a6a11c456ccb",
  measurementId: "G-GFVPHH1BPE"
};

// const defaultFirebaseConfig = {
//   apiKey: "AIzaSyDa54E9N4jVEyGxFNTp-n0rfMZXf5M5AyQ",
//   authDomain: "mymoney-50a03.firebaseapp.com",
//   databaseURL: "https://mymoney-50a03-default-rtdb.firebaseio.com",
//   projectId: "mymoney-50a03",
//   storageBucket: "mymoney-50a03.firebasestorage.app",
//   messagingSenderId: "204627974575",
//   vapidKey: "BCDaU5yzj8kaTxZwsZYYeHMc730UMZIzWN0erR5DJoAhCcE3JkU26eB6_EzwJpLiaZB-ADmEg0iuQlfismVsS1A",
//   appId: "1:204627974575:web:46288c59785a5b6ec8375a"
// };

const authFirebaseConfig = {
  apiKey: "AIzaSyAO8Sq6NqpetEuJsJ3xG7uh-pJMP17PDNw",
  authDomain: "kunaiu-bank.firebaseapp.com",
  databaseURL: "https://kunaiu-bank-default-rtdb.firebaseio.com",
  projectId: "kunaiu-bank",
  storageBucket: "kunaiu-bank.appspot.com",
  messagingSenderId: "55200273605",
  appId: "1:55200273605:web:2143132c9277e9c7efccac"
}

// Firebase configuration for the chat project
const chatFirebaseConfig = {
  apiKey: "AIzaSyDsAPUYaWhEJTxZRjVd_T-sGD5BuG7CvY4",
  authDomain: "amchat2026.firebaseapp.com",
  databaseURL: "https://amchat2026-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "amchat2026",
  storageBucket: "amchat2026.firebasestorage.app",
  messagingSenderId: "144368966545",
  appId: "1:144368966545:web:d52f6eb046d38a2fe05830",
  measurementId: "G-RK3EVCKWKK"
};

// Initialize Firebase (default project)
if (!firebase.apps.length) {
  firebase.initializeApp(defaultFirebaseConfig);
} else {
  firebase.app(); // if already initialized
}

// Set auth persistence
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// Initialize the second Firebase project (chatApp)
const chatApp = firebase.initializeApp(chatFirebaseConfig, "chatApp");

// Initialize the auth Firebase project for authentication
const authApp = firebase.initializeApp(authFirebaseConfig, "authApp");

// Set auth persistence for the auth app
authApp.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export { firebase, chatApp, authApp, defaultFirebaseConfig, authFirebaseConfig };